import axiosInstance from "./axiosInstance";
import { showAlertError } from '../utils/alertHelper';

const basePath = "/reportes";

export const reporteGeneral = async (data) => {
    try {
        const response = await axiosInstance.post(`${basePath}/general`, data);
        return response.data;
    } catch (error) {
        console.error("Error en generar reporte general:", error);
        showAlertError("Error inesperado", "Ocurrió un problema al generar el reporte.");
        throw error;
    }
};
